import { Window } from 'Types/ChiliPiper'
import { Countries } from 'Assets/lists/countries'
import { theme } from '@clickcease/cc-client-components-lib'

export type FormValues = {
  email: string
  phoneNumber: string
}

export const chiliPiper = (window as unknown as Window).ChiliPiper

export const countriesArrayOptions = Countries.map((country) => ({
  label: country.label,
  value: country.label,
}))

export const companySizeOptions = [
  { label: '1-10', value: '1-10' },
  { label: '11-50', value: '11-50' },
  { label: '51-200', value: '51-200' },
  { label: '201-500', value: '201-500' },
  { label: '501-1,000', value: '501-1000' },
  { label: '1,001-5,000', value: '1001-5000' },
  { label: '5,001-10,000', value: '5001-10000' },
  { label: '10,000+', value: '10000+' },
]

export const annualSiteTrafficOptions = [
  { label: '0-1M', value: '0-1M' },
  { label: '1M-3M', value: '1M-3M' },
  { label: '3M-5M', value: '3M-5M' },
  { label: '5M+', value: '5M+' },
]

export const phoneInputStyle = {
  borderColor: theme.colors.lightGray.value,
  height: '33px',
  width: '100%',
  fontFamily: 'inherit',
}
